import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { BaseComponent } from '../../base.component';
import { DataService } from '../../../../../_services/data.service';
import { Roles } from '../../../../../models/enums';
@Component({
    selector: 'app-reservation',
    templateUrl: './reservation.component.html',
    encapsulation: ViewEncapsulation.None
})
export class ReservationComponent extends BaseComponent implements OnInit {
    createVisible: boolean = false;
    searchVisible: boolean = false;
    calendarVisible: boolean = true;
    activeTab: number = 1;
    roles: string[];
    isAdmin: boolean = false;
    isReadOnlyUser: boolean = false;

    constructor(private router: Router, route: ActivatedRoute, private dataService: DataService) {
        super();
        const tab = route.snapshot.queryParams.tab;
        if (tab) {
            if (tab == 2) {
                this.createVisible = true;
                this.router.navigate(['/publisher/reservation']);
            }
            this.activeTab = tab;
        }
    }
    ngOnInit() {
        this.setRoleInfo();
    }

    onClickCreateTab() {
        this.createVisible = true;
    }
    onClickSearchTab() {
        this.searchVisible = true;
        this.calendarVisible = false;
    }
    onClickCalendarTab() {
        this.calendarVisible = true;
        this.searchVisible = false;
    }

    private setRoleInfo() {
        this.roles = this.dataService.roles;
        this.isAdmin = this.roles.includes(Roles.Admin.toString());
        this.isReadOnlyUser = this.roles.includes(Roles.ReadOnlyUser.toString());
    }

}



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/theme/pages/default/publisher/reservation/reservation.component.ts